import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../services/api';

const OpenWerkorders = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const statusFilter = searchParams.get('status');
  const [werkorders, setWerkorders] = useState([]);
  const [monteurs, setMonteurs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [planPopup, setPlanPopup] = useState(null);
  const [planDatum, setPlanDatum] = useState('');
  const [planMonteur, setPlanMonteur] = useState('');
  const [planning, setPlanning] = useState(false);
  const [user, setUser] = useState(null);

  const loadData = async () => {
    try {
      const [woRes, userRes, meRes] = await Promise.all([
        api.get('/werkorders'),
        api.get('/gebruikers'),
        api.get('/auth/me')
      ]);
      setUser(meRes.data.gebruiker || null);
      const open = (woRes.data.werkorders || []).filter(w => w.status !== 'afgerond').filter(w => !(w.status === 'nieuw' && w.doorgestuurd_op)).filter(w => statusFilter ? w.status === statusFilter : true);
      setWerkorders(open);
      const allUsers = userRes.data.gebruikers || [];
      setMonteurs(allUsers.filter(u => u.in_planning));
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  useEffect(() => { loadData();  }, [statusFilter]);

  const handleInplannen = async () => {
    if (!planDatum) return alert('Kies een datum');
    setPlanning(true);
    try {
      await api.post('/planning/plan', {
        werkorder_id: planPopup.id,
        geplande_datum: planDatum,
        monteur_id: planMonteur || null
      });
      setPlanPopup(null);
      setPlanDatum('');
      setPlanMonteur('');
      loadData();
    } catch (err) {
      alert('Fout bij inplannen: ' + (err.response?.data?.error || err.message));
    }
    setPlanning(false);
  };

  const getStatusBadge = (status) => {
    const map = { toegewezen: '📅 Ingepland', in_behandeling: '🔧 In behandeling', nieuw: '🆕 Nieuw', lmra_afgekeurd: '⚠️ LMRA Afgekeurd' };
    const colors = { toegewezen: '#3b82f6', in_behandeling: '#f59e0b', nieuw: '#22c55e', lmra_afgekeurd: '#dc2626' };
    return <span style={{ background: colors[status] || '#64748b', color: 'white', padding: '4px 10px', borderRadius: 12, fontSize: 12, fontWeight: 600 }}>{map[status] || status}</span>;
  };

  const getPrioriteitIcon = (p) => {
    const icons = { hoog: '🔴', middel: '🟡', laag: '🟢' };
    return icons[p] || '🟡';
  };

  if (loading) return <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: 300, gap: 16, color: '#666' }}><p>Laden...</p></div>;

  return (
    <div style={{ padding: 24, maxWidth: 1400, margin: '0 auto', fontFamily: "'Segoe UI', sans-serif" }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h1 style={{ fontSize: 24, color: '#1e293b', margin: 0 }}>{statusFilter === 'in_behandeling' ? '🔧 In Behandeling' : '📋 Openstaande Werkorders'}</h1>
        <button onClick={() => navigate('/dashboard')} style={{ padding: '8px 16px', background: '#1e293b', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14 }}>← Dashboard</button>
      </div>
      <div style={{ background: 'linear-gradient(135deg, #eff6ff, #dbeafe)', border: '1px solid #93c5fd', borderRadius: 12, padding: 20, textAlign: 'center', marginBottom: 24 }}>
        <div style={{ fontSize: 36, fontWeight: 800, color: '#1e293b' }}>{werkorders.length}</div>
        <div style={{ fontSize: 13, color: '#475569' }}>{statusFilter === 'in_behandeling' ? 'IN BEHANDELING' : 'OPENSTAANDE WERKORDERS'}</div>
      </div>
      {werkorders.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 60, color: '#94a3b8' }}>Geen openstaande werkorders</div>
      ) : (
        werkorders.map(wo => (
          <div key={wo.id} style={{ background: 'white', border: '1px solid #f1f5f9', borderRadius: 12, padding: '16px 20px', marginBottom: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.08)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ cursor: 'pointer', flex: 1 }} onClick={() => navigate(`/werkorder/${wo.id}`)}>
              <div style={{ fontWeight: 600, fontSize: 15, color: '#1e293b', marginBottom: 4 }}>{getPrioriteitIcon(wo.prioriteit)} {wo.titel}</div>
              <div style={{ fontSize: 13, color: '#64748b', marginBottom: 6 }}>{wo.beschrijving?.substring(0, 80) || ''}</div>
              <div style={{ display: 'flex', gap: 12, fontSize: 12, color: '#94a3b8' }}>
                <span>📁 {wo.afdeling_naam || 'Geen afdeling'}</span>
                <span>👤 {wo.toegewezen_aan_voornaam || 'Niet toegewezen'}</span>
                <span>📅 {wo.created_at ? new Date(wo.created_at).toLocaleDateString('nl-NL') : ''}</span>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              {(!user || !user.afdeling_id || wo.afdeling_id == user.afdeling_id) && (
              <button onClick={(e) => { e.stopPropagation(); setPlanPopup(wo); setPlanDatum(''); setPlanMonteur(''); }} style={{ padding: '8px 14px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap' }}>📅 Inplannen</button>
              )}
              {getStatusBadge(wo.status)}
            </div>
          </div>
        ))
      )}

      {planPopup && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={() => setPlanPopup(null)}>
          <div style={{ background: 'white', borderRadius: 16, padding: 28, width: 420, maxWidth: '90vw', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }} onClick={e => e.stopPropagation()}>
            <h2 style={{ fontSize: 18, color: '#1e293b', marginBottom: 4 }}>📅 Werkorder Inplannen</h2>
            <p style={{ fontSize: 13, color: '#64748b', marginBottom: 20 }}>{planPopup.titel}</p>

            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#475569', marginBottom: 6 }}>Datum *</label>
              <input type="date" value={planDatum} onChange={e => setPlanDatum(e.target.value)} style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14 }} />
            </div>

            <div style={{ marginBottom: 24 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#475569', marginBottom: 6 }}>Monteur (optioneel)</label>
              <select value={planMonteur} onChange={e => setPlanMonteur(e.target.value)} style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, background: 'white' }}>
                <option value="">-- Kies monteur --</option>
                {monteurs.map(m => <option key={m.id} value={m.id}>{m.voornaam} {m.achternaam}</option>)}
              </select>
            </div>

            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button onClick={() => setPlanPopup(null)} style={{ padding: '10px 20px', background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14 }}>Annuleer</button>
              <button onClick={handleInplannen} disabled={planning || !planDatum} style={{ padding: '10px 20px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600, opacity: planning || !planDatum ? 0.5 : 1 }}>{planning ? 'Bezig...' : '✅ Inplannen'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OpenWerkorders;
